import React from "react";
import Layout from "@/components/Layout";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <Layout>
      <section className="max-w-3xl mx-auto px-6 py-32 text-center" data-testid="not-found-page">
        <div className="overline mb-2">404</div>
        <h1 className="font-heading text-6xl md:text-7xl tracking-tight">Lost in the woods.</h1>
        <p className="text-[#5C5A56] mt-4">The page you're looking for doesn't exist on MapleMarket.</p>
        <Link to="/" className="btn-primary inline-block mt-8">Back to home</Link>
      </section>
    </Layout>
  );
}
